

export class AuthenticationRequestBo {
    userName: string;
    password: string;
    agencyCode: string;
    roleId: string | null;
    type: string = "admin";
}